import React from 'react';
import {Box, Grid} from "@material-ui/core";
import CustomCenterDivider from "../../components/CustomCenterDivder/CustomCenterDivider";
import CustomCenterHeader from "../../components/CustomCenterHeader";
import StackCards from "../../components/StackCards";

const LandingDiner = () => {
    return (<>
        <div className="chef-page-container" style={{ backgroundColor: '#ff8000' }}>
          <div className="chef-page-content chef-page-content-invert" style={{ paddingBottom: 80 }}>
            <h3>Turn Your Kitchen into a Home Restaurant</h3>
            <p>
              Diners can use Cuisine Crafters to have better than restaurant-quality meals provided at home without having to waste time shopping, prepping, or cooking.
            </p>
            <p>
              With Cuisine Crafters, you can skip making reservations, driving and long wait times at restaurants. Your private chef cooks for you while you lounge or do chores and they serves you exclusively!
            </p>
            <p>
              The convenience factor is undeniable. Your private chef will come to your residence during the designated booking window and cook everything fresh for you. They will handle cleanup and depart after service so you can focus on the things that are important to you.
            </p>
          </div>
        </div>

        <div className="chef-page-container" style={{ backgroundColor: '#fff' }}>
          <div className="chef-page-content" style={{ paddingBottom: 80 }}>
            <h3>Enjoy the Food You Want</h3>
            <p>
              Do you like to eat organic foods? Have any gluten, dairy, other dietary restrictions? Your private chef can prepare food according to your dietary preferences. These are experienced chefs that can handle your requests while still providing a delicious, exciting rotation of new dishes.
            </p>
          </div>
        </div>

        <div className="chef-page-container" style={{ backgroundColor: '#ff8000' }}>
          <div className="chef-page-content chef-page-content-invert" style={{ paddingBottom: 80 }}>
            <h3>Your Food Doesn't Have to Be Boring</h3>
            <p>
              Your private chef can prepare dishes from a variety of cuisines. This keeps things interesting for you and your family. Don't settle for the same boring dish over and over again simply because it is convenient to cook. Our chefs can create restaurant-quality meals that cater to all kinds of palettes and flavor profiles. And you can choose among many local chefs and home cooks in your area.
            </p>
          </div>
        </div>
        <div style={{
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
          padding: '60px 10px'
        }}>
            <CustomCenterDivider />

            <CustomCenterHeader text="Enjoy a meal in <span style='color: #ff8000'>3</span> easy steps" computer={true} />

            <Grid className="landing-container" container direction="row" spacing={32}>
                <Box className="landing-box">
                    <StackCards
                        image="/images/find.png"
                        txtHeader="Locate a Chef"
                        txtSub={
                            <div className="landing-card-decription">
                              Use our platform to find a chef near you.
                            </div>
                        }
                        title="Find nearby home cooks"
                        alt="Cuisine Crafters - Find Cooks"
                        step="1"
                    />
                </Box>
                <Box className="landing-box">
                    <StackCards
                        image="/images/book.png"
                        txtHeader="Make a Booking"
                        txtSub={
                            <div className="landing-card-decription">
                              Book your chef on a scheduled date and time. You can also book recurring appointments.
                            </div>
                        }
                        title="View your bookings"
                        alt="Cuisine Crafters - Book Cooks"
                        step="2"
                    />
                </Box>
                <Box className="landing-box">
                    <StackCards
                        image="/images/eat.png"
                        txtHeader="Enjoy Quality Food"
                        txtSub={
                            <div className="landing-card-decription">
                              Your chef will show up on time and prepare quality meals with fresh ingredients.
                            </div>
                        }
                        title="Enjoy Food at home"
                        alt="Cuisine Crafters - Enjoy Food"
                        step="3"
                    />
                </Box>
            </Grid>
        </div>
      </>
    );
};

export default LandingDiner;
